import 'firebase/auth';

import firebase from './firebase-app';

export const { auth } = firebase;
